(function () {
    'use strict';

    /**
     * @ngdoc factory
     * @name manageFlights.factory:ManageFlightsRequestFactory
     *
     * @description
     *
     */
    angular
        .module('fuel')
        .factory('ManageFlightsRequestFactory', ManageFlightsRequestFactory);

    function ManageFlightsRequestFactory() {

        function SearchFlightRequest() {
            this.departureFromDate=null;
            this.departureToDate=null;
            this.departureAirport=null;
            this.arrivalAirport=null;
            this.flightNumber=null;
            this.airCraftModel=null;
            this.startPosition=null;
            this.pageSize=null;
            this.modelNumber=null;
            this.flightStatus = null;
        }

        function SaveFlightRequest() {
            this.onSunday=null;
            this.onMonday=null;
            this.onTuesday=null;
            this.onWednesday=null;
            this.onThursday=null;
            this.onFriday=null;
            this.onSaturday=null;
            this.fromDate=null;
            this.toDate=null;
            this.flightNumber=null;
            this.flightMode=null;
            this.fromAirportCode=null;
            this.toAirportCode=null;
            this.departureTime=null;
            this.arrivalTime=null;
            this.aircraftModelCapacityId=null;
            this.version=null;
            this.includeEts=null;
            this.operationType=null;
        }

        function DisplayFlight() {
            return {
                flightNo:null,
                aircraftModel: null,
                acModelCapacity : null,
                from: null,
                to: null,
                fromDate: null,
                toDate: null,
                departureTime: null,
                arrivalTime: null,
                flightMode: null,
                flightLegId: null,
                operationType: null
            }
        }

        var searchFlightRQ = function (searchParams) {
            var searchFlight = new SearchFlightRequest();
            searchFlight.departureAirport = angular.isUndefined(searchParams.from.value) || searchParams.from.value === null || searchParams.from.value.airPortCode === 'ANY' ? null : searchParams.from.value.airPortCode;
            searchFlight.arrivalAirport = angular.isUndefined(searchParams.to.value) || searchParams.to.value === null || searchParams.to.value.airPortCode === 'ANY' ? null : searchParams.to.value.airPortCode;
            if (searchParams.aircraftModel !=null){
              searchFlight.modelNumber = angular.isUndefined(searchParams.aircraftModel) || searchParams.aircraftModel.model==='ANY' ? null : $.trim(searchParams.aircraftModel.model);
            }
            if(searchParams.flightStatus){
              searchFlight.flightStatus = $.trim(searchParams.flightStatus.flightStatusCode);
            } else {
              searchFlight.flightStatus = 'SCH';
            }
            searchFlight.departureFromDate = searchParams.fromDate;
            searchFlight.departureToDate = searchParams.toDate;
            searchFlight.flightNumber = searchParams.flightNumber.value;
            searchFlight.pageSize = searchParams.pageSize;
            searchFlight.startPosition = searchParams.startPosition;
            return searchFlight;
        };

        var getDisplayFlight = function () {
            return new DisplayFlight();
        };

        var getSaveFlightRQ = function (flightInfo, weekData) {
            var saveFlight = new SaveFlightRequest();
            saveFlight.flightMode = angular.isUndefined(flightInfo.flightMode) || flightInfo.flightMode ===null ? null:flightInfo.flightMode.value;
            saveFlight.flightNumber = flightInfo.flightNo;
            saveFlight.arrivalTime = flightInfo.arrivalTime;
            saveFlight.toDate = flightInfo.toDate;
            saveFlight.departureTime = flightInfo.departureTime;
            saveFlight.fromDate = flightInfo.fromDate;
            saveFlight.operationType = flightInfo.operationType.operationTypeCode;
            saveFlight.fromAirportCode = angular.isUndefined(flightInfo.from) || flightInfo.from ===null ? null:flightInfo.from.airPortCode;
            saveFlight.toAirportCode = angular.isUndefined(flightInfo.to) || flightInfo.to === null ? null:flightInfo.to.airPortCode;
            saveFlight.aircraftModelCapacityId = !!flightInfo.acModelCapacity ? flightInfo.acModelCapacity.modelCapacityId : null;
            saveFlight.version = -1;
            for(var i=1;i<weekData.length;i++){
                saveFlight['on' + weekData[i].name] = weekData[i].selected;
            }
            return saveFlight;
        };

        return{
            searchFlightRQ: searchFlightRQ,
            getDisplayFlight: getDisplayFlight,
            getSaveFlightRQ: getSaveFlightRQ
        }
    }
})();
